import { AfterViewInit, Component, ChangeDetectorRef } from '@angular/core';
import { UiHelper } from '@helpers/ui.helper';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { CurrentSlipComponent } from './current-slip.component';
import { DataHelper } from '@helpers/data.helper';
import { TranslateService } from '@services/translate.service';
import { LocalizationService } from '@services/localization.service';
import { BOTTOM_NAVBAR_ITEMS, environment } from '@environments/environment';
import { ApiService } from '@services/api.service';
import { UserHelper } from '@helpers/user.helper';

@Component({
  selector: 'bottom-navbar',
  templateUrl: '../sharedTemplates/bottom-navbar.component.html',
})
export class BottomNavbarComponent implements AfterViewInit {
  activeItem;
  public routeDatas = BOTTOM_NAVBAR_ITEMS;
  history = [];
  dontOpenLeft = false;
  routeDatasC;

  constructor(
    public _UiHelper: UiHelper,
    public _UserHelper: UserHelper,

    private _router: Router,
    private _BottomSheet: MatBottomSheet,
    public _DataHelper: DataHelper,
    public _LocalizationService: LocalizationService,
    private _ApiService: ApiService,
    private ref: ChangeDetectorRef,
    private _TranslateService: TranslateService
  ) {
    this._UserHelper.signInListener.subscribe(x => {
      if (x == true) {
        this.routeSizer();
      } else {
        this.ref.detectChanges();
        this.routeSizer();
      }

      if (this._UserHelper.customerUser != undefined && this._UserHelper.customerUser.CustomerId != undefined)
        this._ApiService.getWalletList().then(result => {
          this._UserHelper.walletList = result;

          this._UserHelper.walletListLoadingListener.emit(true);
        });
    });

    this._UiHelper.bottomNavbarNavigateListener.emit(v => {
      this._UiHelper.bottomActiveItem = v;
    });

    this.countUpdater(5, this._DataHelper.numberOfBets);
    this.countUpdater(15, this._DataHelper.numberOfBets);
    this._DataHelper.numberOfBetsListener.subscribe(x => {
      this.countUpdater(5, x);
      this.countUpdater(15, x);
      this.routeSizer();
      if (x != 0) {
        this.calculateSlipAmount();
      }
    });

    this.countUpdater(4, this._DataHelper.numberOfCashout);
    this._DataHelper.numberOfCashoutListener.subscribe(x => {
      this.countUpdater(4, x);
      this.routeSizer();
    });
  }

  bottomMenuToogler(e) {
    this._UiHelper.closeAllMenus();
    if (e == 5) {
      this._UiHelper.p1001SetBottomDialogState('close');
      this._UiHelper.p1001SetMatchDetailDialog('close');
      if (this._DataHelper.numberOfBets > 0) {
        this._BottomSheet.open(CurrentSlipComponent, { panelClass: 'currentSlipBS' });
      } else {
        this._UiHelper.fireSnackBar(this._TranslateService.instant('zero_bet'), this._TranslateService.instant('okay'));
      }
    } else if (e == 2) {
      this._UiHelper.p1001SetMatchDetailDialog('close');
      this._UiHelper.p1001SetBottomDialogState('close');
      if (environment.leftsport) {
        this.dontOpenLeft ? (this.dontOpenLeft = false) : this._UiHelper.setLeftSportsMenuDialog(true);
      }

      this._router.navigate([this.routeDatas.find(x => x.id === 2).route]);
      this._UiHelper.bottomActiveItem = e;
    } else if (e === 15) {
      this._UiHelper.p1001SetMatchDetailDialog('close');
      this._UiHelper.p1001SetBottomDialogState('open');
      this._UiHelper.bottomActiveItem = e;
    } else {
      if (e === 4) {
        if (this._UserHelper.isSignedIn == true) {
          this._UiHelper.setBottomNavbarNavigate(e);
          this._UiHelper.p1001SetMatchDetailDialog('close');
          this._UiHelper.p1001SetBottomDialogState('close');
          if (this._UiHelper.bottomActiveItem != e) {
            this._router.navigate([this.routeDatas.find(x => x.id === e).route]);
          }
          this._UiHelper.bottomActiveItem = e;
        } else {
          this._UiHelper.p1001SetMatchDetailDialog('close');
          this._UiHelper.SetRightMenuState('open');
        }
      } else if (e === 6) {
        //Kullanıcı casino uygulamasına girebilmesi için login olmak zorundadır kontrol bu yüzdendir.

        if (this._UserHelper.isSignedIn) {
          this._UiHelper.setBottomNavbarNavigate(e);
          this._UiHelper.p1001SetMatchDetailDialog('close');
          this._UiHelper.p1001SetBottomDialogState('close');
          this._router.navigate([this.routeDatas.find(x => x.id === 6).route]);
          this._UiHelper.bottomActiveItem = e;
        } else {
          this._UiHelper.SetRightMenuState('open');
        }
      } else {
        this._UiHelper.setBottomNavbarNavigate(e);
        this._UiHelper.p1001SetBottomDialogState('close');
        this._UiHelper.p1001SetMatchDetailDialog('close');

        if (this._UiHelper.bottomActiveItem != e) {
          this._router.navigate([this.routeDatas.find(x => x.id === e).route]);
        }
        this._UiHelper.bottomActiveItem = e;
      }
    }
  }

  togglerByUrl(s) {
    let a = 0;
    this.routeDatas.forEach((x, c) => {
      if (x.route == s) {
        this.bottomMenuToogler(x.id);
        a++;
      }
    });

    a == 0 ? (this._UiHelper.bottomActiveItem = undefined) : null;
  }

  countUpdater(_id, newCount) {
    this.routeDatas.forEach((x, c) => {
      x.id == _id ? (x.count = newCount) : null;
    });
  }

  routeSizer() {
    this.routeDatasC = [];
    this.routeDatas.forEach((x, c) => {
      x.isCountZeroHide && (x.count == 0 || x.count == undefined) ? null : this.routeDatasC.push(x);
    });
  }

  ngAfterViewInit() {
    this._router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(({ urlAfterRedirects }: NavigationEnd) => {
      this._UiHelper.setCurrentRoute(urlAfterRedirects);
      urlAfterRedirects != '/' ? this.togglerByUrl(urlAfterRedirects) : (this._UiHelper.bottomActiveItem = null);
      this.history = [...this.history, urlAfterRedirects];
      const b = new RegExp('[a-z|A-Z||.|:||-|/]*');
      if (b.exec(this.history[this.history.length - 1])[0] == '/sports') {
        if (b.exec(this.history[this.history.length - 2])[0] == '/eventdetail/') {
          if (b.exec(this.history[this.history.length - 3])[0] == '/sports') {
            this.dontOpenLeft = true;
          }
        }
      }
      if (b.exec(this.history[this.history.length - 1])[0] == '/sports') {
        if (b.exec(this.history[this.history.length - 2])[0] == '/league') {
          this.dontOpenLeft = true;
        }
      }
      this.togglerByUrl(this._router.url);
    });
    this.routeSizer();
  }
  calculateSlipAmount() {
    if (!this._DataHelper.currentSlipOpened) {
      this._ApiService.getCurrentSlipAmount(1, 2, '').then(result => {
        if (result != null) {
          this._DataHelper.currentSlipInfo.currentTotalRate = result.TotalRate * 1;
        }
      });
    }
  }
}
